import { type IInstructionFeedbackActivityProduct } from "@/interfaces/api/instruction-feedback-activity-product.interface"
import { BaseModelWithFiles } from "@/models/base-with-files.model"
import { Product } from "@/models/product.model"
import { ModelFactory } from "@/factories/model-factory"

export class InstructionFeedbackActivityProduct
  extends BaseModelWithFiles
  implements IInstructionFeedbackActivityProduct
{
  public static className = "InstructionFeedbackActivityProduct"
  public static verboseName = "Instruction Feedback Activity Product"

  instructionFeedbackActivity: string
  product?: Product | null

  quantity?: string
  customProductName?: string | null

  constructor(
    instructionFeedbackActivityProduct: IInstructionFeedbackActivityProduct,
    managed = false
  ) {
    super(instructionFeedbackActivityProduct, managed)

    this.instructionFeedbackActivity =
      instructionFeedbackActivityProduct.instructionFeedbackActivity
    this.product = ModelFactory.childModel(
      Product,
      instructionFeedbackActivityProduct.product,
      managed
    )
    this.quantity = instructionFeedbackActivityProduct.quantity
    this.customProductName = instructionFeedbackActivityProduct.customProductName
  }

  public getProductDisplayText(): string {
    return this.product?.getDisplayText() || this.customProductName || "<no product name>"
  }
}
